import { BigLoader } from "@circle-react-shared/BigLoader";
import { useFetchPlan } from "@circle-react-shared/UpgradePlan/hooks/useFetchPlan";
import { Modal } from "@circle-react-uikit/ModalV2";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { MINIMUM_REQUIRED_PLAN_TIER } from "@circle-react/components/SettingsApp/CommunityAi/constants";
import { usePlanStatus } from "@circle-react/hooks/usePlanStatus";

import { t } from "@/i18n-js/instance";

import { ACTIVITY_SCORES_FEATURE } from "./constants";
import type { FeatureType } from "./constants";
import { ModalBody } from "./ModalBody";
import { ModalFooter } from "./ModalFooter";
import { ModalHeader } from "./ModalHeader";

interface CommunityAiUpgradeModalUIKitComponentProps {
  afterClose?: () => void;
  feature?: FeatureType;
  onSuccess?: () => void;
  source?: string;
}

export const CommunityAiUpgradeModalUIKitComponent = ({
  afterClose,
  feature = ACTIVITY_SCORES_FEATURE,
  source,
  onSuccess,
}: CommunityAiUpgradeModalUIKitComponentProps) => {
  const modal = useModal();
  const { changePlanModalParams } = usePlanStatus();
  const planTierOrId = changePlanModalParams(MINIMUM_REQUIRED_PLAN_TIER);
  const { planTier, planId } = planTierOrId;

  const { plan, isPlanLoading } = useFetchPlan({
    planTier,
    planId,
  });

  const handleClose = () => {
    afterClose?.();
    void modal.hide();
    modal.remove();
  };

  return (
    <Modal
      title={`${t("settings.community_ai.marketing_modal.title.unlock")} ${t(
        "settings.community_ai.marketing_modal.title.community_ai",
      )}`}
      isOpen={modal.visible}
      onClose={handleClose}
    >
      <Modal.Overlay />
      <Modal.Content size="md">
        {isPlanLoading ? (
          <div className="my-28">
            <BigLoader />
          </div>
        ) : (
          <>
            <ModalHeader handleClose={handleClose} />
            <ModalBody feature={feature} />
            <ModalFooter
              handleClose={handleClose}
              plan={plan}
              source={source}
              onSuccess={onSuccess}
            />
          </>
        )}
      </Modal.Content>
    </Modal>
  );
};
